import { ethers } from 'ethers'
import { simpleRpcProvider } from 'utils/providers'
import { poolsConfig } from 'config/constants'
import { PoolCategory } from 'config/constants/types'
import tokens from 'config/constants/tokens'
// Addresses
import { getAddress, getMasterChefAddress, getMulticallAddress } from 'utils/addressHelpers'
// ABI
import bep20Abi from 'config/abi/erc20.json'
import cakeAbi from 'config/abi/cake.json'
import masterChef from 'config/abi/masterchef.json'
import sousChef from 'config/abi/sousChef.json'
import sousChefV2 from 'config/abi/sousChefV2.json'
import sousChefBnb from 'config/abi/sousChefBnb.json'
import MultiCallAbi from 'config/abi/Multicall.json'

const getContract = ( abi: any, address: string, signer?: ethers.Signer | ethers.providers.Provider ) => {
  const signerOrProvider = signer ?? simpleRpcProvider
  return new ethers.Contract( address, abi, signerOrProvider )
}

export const getBep20Contract = ( address: string, signer?: ethers.Signer | ethers.providers.Provider ) => {
  return getContract( bep20Abi, address, signer )
}
export const getSouschefContract = ( id: number, signer?: ethers.Signer | ethers.providers.Provider ) => {
  const config = poolsConfig.find( ( pool ) => pool.sousId === id )
  const abi = config.poolCategory === PoolCategory.BINANCE ? sousChefBnb : sousChef
  return getContract( abi, getAddress( config.contractAddress ), signer )
}
export const getSouschefV2Contract = ( id: number, signer?: ethers.Signer | ethers.providers.Provider ) => {
  const config = poolsConfig.find( ( pool ) => pool.sousId === id )
  return getContract( sousChefV2, getAddress( config.contractAddress ), signer )
}
export const getCakeContract = ( signer?: ethers.Signer | ethers.providers.Provider ) => {
  return getContract( cakeAbi, tokens.goge.address, signer )
}
export const getMasterchefContract = ( signer?: ethers.Signer | ethers.providers.Provider ) => {
  return getContract( masterChef, getMasterChefAddress(), signer )
}
export const getMulticallContract = ( signer?: ethers.Signer | ethers.providers.Provider ) => {
  return getContract( MultiCallAbi, getMulticallAddress(), signer )
}